import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          RootLayout: {
            title: 'Cyrielle Chasles',
            description: "Cyrielle Chasles' portfolio, as a frontend engineer (react and next.js)",
          },
          NavBar: {
            about: 'About',
            projects: 'Projects',
            experience: 'Experience',
          },
          HomePage: {
            title: 'Fullstack & AI Engineer',
            subtitle: 'I use artifical intelligence to create easy-to-use, maintainable web applications',
            available: 'Currently available',
            about: {
              paragraph1:
                "I'm a developer and I love creating beautiful, easy-to-use applications that solve real problems. I'm passionate about the entire development journey, from the conception to the implementation, and I especially enjoy being part of the design process.",
              paragraph2:
                "I use React and Next to bring my projects to life, but I'm always ready to try new technologies. I worked on large codebases in my previous experience, collaborating with a team of other developers, but I also work autonomously on personal projects. I'm currently maintaining a platform (react / nodejs) that I created in December 2022 and that now has over 1000 users.",
              paragraph3: "When I'm not coding, there's a good chance you'll find me reading, crocheting or enjoying a football game!",
            },
            projects: {
              jarvis: {
                name: 'Jarvis',
                description:
                  'Built and deployed an app that allows people to handle their household tasks. They can create a house, list their tasks and share them with other people in their household.',
              },
              airpeger: {
                name: 'Airpéger',
                description:
                  'Built and deployed a platform that helps RPG writers organize their characters, write their stories, and track their progress. I used React to create the app and Node.js for the API. Over the years, the platform has evolved with user feedback and new feature suggestions, and it now has over 1000 users.',
              },
              amigurumoi: {
                name: 'Amigurumoi',
                description:
                  'Developed and deployed a platform that allows crocheters to list, rate, and share their favorite amigurumi (plushies) patterns. Crocheters can use filters to find new patterns, and save patterns they are interested in to their profile, to find them anytime they want. I used Next.js and Typescript for the development, and MongoDB for the database.',
              },
              kasa: {
                name: 'Kasa',
                description: 'Integrating the Kasa website with React. Using states, componants and uploading the website on Github pages.',
              },
              kanap: {
                name: 'Kanap',
                description:
                  "Integrating the Kanap website with Javascript. Getting the data from the API, creating a functioning cart with local storage, and sending the user's order to the server.",
              },
            },
            experiences: {
              ato: {
                name: 'Allianz Trade Online',
                description:
                  "Contributing to several projects (web application, BFF, design system, ...) in collaboration with a team of other developers. Developping new features, correcting bugs, reviewing the team's PRs, and participating in all Agile rituals (scrum).",
                title: 'Fullstack Engineer',
              },
              openclassrooms: {
                name: 'OpenClassrooms',
                description:
                  'Managing the knowledge for the entire Ops team. Customizing our Help Center theme (HTML/CSS), and creating a dynamic contact form (Javascript). Defining and tracking our success metrics (content quality, impact, ...)',
                title: 'Knowledge Management Specialist',
              },
              drivy: {
                name: 'Drivy',
                description:
                  'Writing and updating the Help Center across 6 countries. Passing on the user feedback via an internal newsletter. Reshaping our macro system and writing it across 6 countries, and optimizing the support team processes.',
                title: 'Customer Support Project Manager',
              },
              leboncoin: {
                name: 'Leboncoin (Schibsted)',
                description:
                  "Answering user questions, and gathering user feedback and suggestions for Product & UX improvements. Sending and analysing NPS surveys, and optimizing the team's processes. Analysing user behaviour using webanalytics and user testing.",
                title: 'Customer Success Manager',
              },
            },
            download: 'Download my resume',
            'get-in-touch': 'Want to get in touch?',
            'contact-me': 'Reach out to me on ',
            'or-by': ' or by ',
          },
          Footer: {
            'made-with': 'Made with ',
            using: ' using ',
            and: ' and ',
          },
        },
      },
      fr: {
        translation: {
          RootLayout: {
            title: 'Cyrielle Chasles',
            description: 'Portfolio de Cyrielle Chasles, développeuse front end (react, next.js)',
          },
          NavBar: {
            about: 'À propos',
            projects: 'Projets',
            experience: 'Expérience',
          },
          HomePage: {
            title: 'Développeuse Fullstack & IA',
            subtitle: "J'utilise l'intelligence artificielle pour créer des applications web qui sont simples d'utilisation et maintenables",
            available: 'Disponible',
            about: {
              paragraph1:
                "Je suis développeuse et j'aime créer des applications qui sont faciles à utiliser, élégantes, et qui répondent à de véritables problématiques. Tout le process de développement m'intéresse, de la conception à l'implémentation, et j'aime particulièrement pouvoir participer au processus de design.",
              paragraph2:
                "J'utilise React et Next pour donner vie à mes projets, mais je suis toujours curieuse d'apprendre à utiliser de nouvelles technologies. J'ai travaillé sur de larges code bases en entreprise, en collaboration avec de nombreux développeurs, mais également en autonomie sur des projets personnels. Je maintiens une plateforme (react / nodejs) que j'ai créée en Décembre 2022, et qui compte aujourd'hui plus de 1000 utilisateurs.",
              paragraph3: 'Quand je ne suis pas en train de coder, vous me trouverez surement en train de lire, de faire du crochet, ou de regarder un match de football !',
            },
            projects: {
              jarvis: {
                name: 'Jarvis',
                description:
                  "Création et déploiement d'une application qui permet de suivre ses tâches ménagères. Les membres peuvent créer une maison, lister leurs tâches et les partager avec d'autres membres de leur foyer.",
              },
              airpeger: {
                name: 'Airpéger',
                description:
                  "Création et déploiement d'une plateforme qui permet aux membres de la communauté RPG d'organiser leurs personnages, d'écrire leurs histoires et de suivre leurs statistiques. J'ai utilisé React pour l'application et Node.js pour l'API. Depuis le lancement, l'application a beaucoup évolué avec les retours utilisateurs, et elle compte désormais plus de 1000 utilisateurs.",
              },
              amigurumoi: {
                name: 'Amigurumoi',
                description:
                  "Développement et déploiement d'une plateforme qui permet de recenser ses patrons préférés au crochet (amigurumi), de les sauvegarder, de leur attribuer une note, et de les partager avec le reste de la communauté. J'ai utilisé Next.js et Typescript pour le développement, ainsi que MongoDB pour la base de données.",
              },
              kanap: {
                name: 'Kanap',
                description: "Intégration du site Kanap avec Javascript. Récupération des produits avec une API, création d'un panier via le local storage, et envoi de la commande au serveur.",
              },
              kasa: {
                name: 'Kasa',
                description: 'Intégration du site Kasa en React. Utilisation des states React, des composants, et mise en ligne du site via Github pages.',
              },
            },
            experiences: {
              ato: {
                name: 'Allianz Trade Online',
                description:
                  'Contribution à plusieurs projets (web application, BFF, design system, ...) en collaboration avec une équipe de développeurs. Développement de nouvelles fonctionnalités, correction de bugs, review des PRs de la squad, et participation aux rituels Agile (scrum).',
                title: 'Développeuse Fullstack',
              },
              openclassrooms: {
                name: 'OpenClassrooms',
                description:
                  "Gestion de la connaissance pour toute l'équipe Opérations. Personnalisation de nos thèmes Help Center (HTML/CSS), et création d'un formulaire de contact dynamique (Javascript). Définition et suivi des indicateurs (qualité, impact, ...)",
                title: 'Knowledge Management Specialist',
              },
              drivy: {
                name: 'Drivy',
                description:
                  "Rédaction et mise à jour du Help Center (6 pays). Remontée des retours utilisateurs via une newsletter interne. Refonte et rédaction du système de macros (6 pays) ainsi que des procédures de l'équipe Support.",
                title: 'Chef de projet Service Client',
              },
              leboncoin: {
                name: 'Leboncoin (Schibsted)',
                description:
                  "Traitement des demandes utilisateur, et remontée de leurs problèmes et suggestions. Envoi d'enquêtes de satisfaction et optimisation des procédures de l'équipe. Analyse des comportements utilisateurs sur plusieurs produits (web analytics & user testing)",
                title: 'Chargée de prod et process Relation Client',
              },
            },
            download: 'Télécharger mon CV',
            'get-in-touch': 'Vous souhaitez en savoir plus ?',
            'contact-me': 'Contactez-moi via ',
            'or-by': ' ou par ',
          },
          Footer: {
            'made-with': 'Fait avec ',
            using: ' en utilisant ',
            and: ' et ',
          },
        },
      },
    },
  })

export default i18n
